module.exports = __webpack_public_path__ + "img/whatsapp.392f3719.svg";